import moment from "moment";
import React, { Fragment } from "react";
import styled from "styled-components";
import { Progress } from "antd";
import { functionService } from "../../../lib/functions";
import { useState, useEffect } from "react";
import { useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { PlayCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import {
  coffeeeIcon,
  correctIcon,
  inCorrectIcon,
  RedFlagsImage,
  orangeFlag,
  greenFlag,
} from "./reportImages";
import { BoldText } from "./Styled";
import Score from "./Score";

import { progressBarColor } from "./commonFunctions";

const skillBarColor = (pct, passing) => {
  if (passing == null || passing === "" || Number.isNaN(Number(passing))) {
    if (pct < 40) return "rgba(240, 70, 57, 1)";
    if (pct <= 60) return "rgba(246, 140, 80, 1)";
    return "#0DC10A";
  }
  const pass = Number(passing);
  if (pct >= pass) return "#0DC10A";
  if (pct >= pass - 15) return "rgba(246, 140, 80, 1)";
  return "rgba(240, 70, 57, 1)";
};

const visibleTopicName = (topicName) => {
  const name = String(topicName || "").trim();
  if (!name || name === "-") return "";
  return name;
};

// ─── Styled Components (synced to working version) ───────────────────────────

const ReportContentWrapper = styled.div`
  padding: 15px;
  background: #fafafe;
`;
const ContainerBox = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(27, 73, 234, 0.15);
  display: flex;
  flex-direction: column;
  padding: 15px;
  margin-bottom: 30px;
  /* page-break-before: ${(props) => (props.pageBreakBefore ? "always" : "")}; */
  margin-top: ${(props) => (props.top ? props.top : "")};
`;
const FirstRow = styled.div`
  display: flex;
  margin-bottom: 40px;
  & > div {
    flex: 1;
    margin-right: 10px;
    &:last-child {
      margin-right: 0px;
    }
    > div {
      font-size: 12px;
      &:last-child {
        font-weight: 700;
        width: 160px;
        word-wrap: break-word;
        hyphens: auto;
      }
    }
  }
`;
const SecondRow = styled.div`
  display: flex;
  & > div {
    flex: 1;
    font-size: 12px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0px;
    }
    > div {
      &:last-child {
        font-weight: 700;
      }
    }
  }
`;
const SectionHeading = styled.p`
  color: #ff2c91;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 12px;
`;
const ScoreWrapper = styled.div`
  display: flex;
  flex: 1;
`;
const RecordingUrl = styled.a`
  color: #1b49ea;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
`;
const Line = styled.div`
  border-radius: 10px;
  background: #9cc4d8;
  box-shadow: 0px 0px 10px 0px rgba(27, 73, 234, 0.15);
  width: 100%;
  height: 0.5px;
  margin: 50px 0 40px 0;
`;
const ProgressContainer = styled.div`
  width: 250px;
`;
const ContainerText = styled.p`
  color: #1e2228;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 30px 0 12px 0;
`;
const RedFlags = styled.p`
  position: absolute;
  top: -2px;
  left: 33px;
  color: #1e2228;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 30px;
`;
const ProgressBarWrapper = styled.div`
  width: 250px;
  margin-bottom: 12px;
  position: relative;
  height: 14px;
  overflow: hidden;
  .ant-progress {
    line-height: 14px;
    height: 14px;
  }
  .ant-progress-outer {
    padding-right: 0 !important;
    margin-right: 0 !important;
  }
  .ant-progress-inner {
    height: 14px !important;
    border: 1px solid #9cc4d8;
    background-color: #f5f5f5 !important;
  }
`;
const PassingMarker = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  height: auto;
  width: 2px;
  background: #1e2228;
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: none;
`;
const PercentContainer = styled.div`
  position: relative;
  width: 250px;
  height: 35px;
  margin-top: 13px;
  & > span {
    position: absolute;
    top: 0;
    color: #1e2228;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    transform: translateX(-50%);
  }
  & > span:first-child {
    transform: none;
  }
  & > span:last-child {
    transform: translateX(-100%);
  }
`;
const LeftSideSkillContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > span {
    height: 26px;
    display: flex;
    align-items: center;
    color: #1e2228;
    text-align: center;
    margin-right: 15px;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    width: 180px;
    white-space: break-spaces;
    line-height: normal;
  }
`;
const RightScoreContainer = styled.div`
  display: flex;
  padding: 0 60px;
  border-left: ${(props) =>
    props.hideBorder ? "none" : "0.5px solid #9cc4d8"};
`;
const AssessmentTypeHeading = styled.p`
  color: #1e2228;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 10px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  > div {
    &:last-child {
      font-weight: 400;
    }
  }
`;
const ListingContainer = styled.div`
  border: 1px solid #9cc4d8;
  background: #fff;
  padding: 30px;
`;
const MockScoreContainer = styled.div`
  display: flex;
  width: 100%;
  & > p {
    flex: 1;
    width: 100%;
    font-size: 12px;
    margin: 0px;
    &:first-child {
      flex: 0.5;
    }
  }
`;
const RecordingCard = styled.div`
  height: 120px;
  width: 120px;
  border: 1px solid #9cc4d8;
  background-size: cover;
  background-position: center;
  background-image: url(${(props) => props.backgroundImage});
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  position: relative;
`;
const RecordingLink = styled.a`
  margin-top: 10px;
  background-color: rgba(250, 250, 254, 1);
  font-size: 12px;
  padding: 20px;
  width: 100%;
  border-radius: 10px;
  & > p {
    margin: auto;
    font-size: 12px;
    color: white;
    background-color: red;
    width: fit-content;
    border-radius: 4px;
    padding: 2px 5px;
  }
`;
const MockQuestionContainer = styled.div`
  margin-bottom: 10px;
  font-size: 12px;
  display: flex;
  & > p {
    flex: 1;
  }
  & > div {
    &:first-child {
      width: 70px !important;
    }
  }
`;
const ItemContainer = styled.div`
  /* page-break-inside: avoid; */
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
`;
const AIComparisonFeedback = styled.div`
  margin-bottom: 20px;
  font-size: 13px;
  &:last-child {
    margin-bottom: 0;
  }
`;
const CodingContainer = styled.div`
  border: 1px solid #9cc4d8;
  background: #fff;
  padding: 30px;
`;
const CodingQuestionContainer = styled.div`
  display: flex;
  & > p {
    margin: 0;
    font-size: 12px;
    flex: 1;
    & > img {
      margin-right: 6px;
    }
    &:first-child {
      flex: 0.5;
      width: 100px;
    }
    & > span {
      font-weight: 700;
    }
  }
`;
const CodingQuestionDetail = styled.div`
  white-space: pre-line;
  margin-top: 20px;
  font-size: 12px;
`;
const CandidateCodeHeading = styled.p`
  color: #1e2228;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 30px 0 12px 0;
`;
const CandidateCode = styled.p`
  color: ${(props) => (props.red ? "red" : "#1e2228")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "10px")};
  font-style: normal;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 400)};
  line-height: normal;
  white-space: pre-line;
  background: #f7f8f9;
  padding: 30px;
`;
const McqContainer = styled.div`
  border: 1px solid #9cc4d8;
  background: #fff;
  padding: 30px;
`;
const OptionWrapper = styled.div`
  font-size: 12px;
  background-color: ${(props) =>
    props.correct === true
      ? "#B4FFDE"
      : props.correct === false
      ? "#FFE6E4"
      : "#FAFAFE"};
  width: 60%;
  border-radius: 8px;
  padding: 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > p {
    margin: 0;
  }
`;
const Text = styled.p`
  color: #1e2228;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 30px 0 12px 0;
`;
const ScoreValues = styled.p`
  color: #1e2228;
  font-size: 12px;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 2px;
  margin-bottom: 12px;
`;
const Box = styled.div`
  > div {
    &:last-child {
      width: fit-content;
    }
  }
`;

// ─── Component ────────────────────────────────────────────────────────────────

const Report = ({ data, count }) => {
  console.log("Imported content is ------->", data, count);

  return (
    <div style={{ zIndex: "100", width: "100%", position: "absolute" }}>
      <div style={{ display: "none" }}>
        {data && (
          <div id={`pdf-content-${data.id}`} style={{ width: "100%" }}>
            {/* Header */}
            <div
              style={{
                display: "flex",
                background: "#0C2272",
                height: "70px",
                alignItems: "center",
                padding: "20px",
                justifyContent: "space-between",
              }}
            >
              <img alt="" src={coffeeeIcon} />
              <p style={{ color: "white", fontWeight: "700", fontSize: "14px" }}>
                Coffeee Assessment Report
              </p>
            </div>

            <ReportContentWrapper>
              {/* ── Overall Summary ── */}
              <ContainerBox>
                <SectionHeading>Overall Summary</SectionHeading>
                <FirstRow>
                  <div>
                    <div>Name</div>
                    <div>{data?.name}</div>
                  </div>
                  <div>
                    <div>Email</div>
                    <div>{data?.email}</div>
                  </div>
                  <div>
                    <div>Invited by</div>
                    {data?.invitedby_name ? (
                      <div>{data.invitedby_name}</div>
                    ) : (
                      <div>NA</div>
                    )}
                  </div>
                  <div>
                    <div>Assessment title</div>
                    <div>{data?.test_title}</div>
                  </div>
                </FirstRow>
                <SecondRow>
                  <div>
                    <div>Assessment valid from</div>
                    {data?.start_date ? (
                      <div>{`${moment(data?.start_date).format("DD")}-${moment(data?.start_date).format("MMM")}-${moment(data?.start_date).format("YY")}`}</div>
                    ) : (
                      <div>-</div>
                    )}
                  </div>
                  <div>
                    <div>Assessment valid to</div>
                    <div>{`${moment(data?.expiry_date).format("DD")}-${moment(data?.expiry_date).format("MMM")}-${moment(data?.expiry_date).format("YY")}`}</div>
                  </div>
                  <div>
                    <div>Assessment submitted on</div>
                    {data.submitted_on ? (
                      <div>{`${moment(data?.submitted_on).format("DD")}-${moment(data?.submitted_on).format("MMM")}-${moment(data?.submitted_on).format("YY")}, ${moment(data?.submitted_on).format("LT")}`}</div>
                    ) : (
                      <div>-</div>
                    )}
                  </div>
                  <div>
                    <div>Difficulty level</div>
                    <div>
                      {data?.difficulty_level.charAt(0).toUpperCase()}
                      {data?.difficulty_level.slice(1).toLowerCase()}
                    </div>
                  </div>
                </SecondRow>
              </ContainerBox>

              {/* ── Assessment Summary ── */}
              <ContainerBox>
                <SectionHeading>Assessment Summary</SectionHeading>
                <ScoreWrapper>
                  <Score
                    stroke={13.5}
                    title={"Overall Score"}
                    percent={data?.overAll}
                    color={
                      data?.overAll < 40
                        ? "rgba(240, 70, 57, 1)"
                        : data.overAll >= 40 && data.overAll <= 60
                        ? "rgba(246, 140, 80, 1)"
                        : "#0DC10A"
                    }
                    size={80}
                    text={"Questions attempted"}
                    boldText={
                      data?.total_questions_attempt +
                      "/" +
                      data?.total_questions
                    }
                  />
                  {
                    <Score
                      stroke={13.5}
                      title={"Tech Score"}
                      percent={data?.techScore}
                      color={
                        data?.techScore < 40
                          ? "rgba(240, 70, 57, 1)"
                          : data.techScore >= 40 && data.techScore <= 60
                          ? "rgba(246, 140, 80, 1)"
                          : "#0DC10A"
                      }
                      size={80}
                      text={"Marks obtained"}
                      boldText={`${data?.overAllCorrectMarks}/${data?.overAllMarks} (${data?.techScore}%)`}
                    />
                  }
                  {data?.totalMock > 0 && (
                    <Score
                      stroke={13.5}
                      title={"Communication Proficiency"}
                      percent={data?.proficiency}
                      color={
                        data?.proficiency < 40
                          ? "rgba(240, 70, 57, 1)"
                          : data.proficiency >= 40 && data.proficiency <= 60
                          ? "rgba(246, 140, 80, 1)"
                          : "#0DC10A"
                      }
                      size={80}
                      text={"Time taken"}
                      boldText={`${
                        data?.progress_min?.toString().split(".")[0]
                      } Min. ${
                        data?.progress_min.toString()?.split(".")[1]
                          ? `${
                              String(
                                (Number(
                                  data?.progress_min
                                    .toString()
                                    ?.split(".")[1]
                                    .slice(0, 2)
                                    .padEnd(2, "0")
                                ) *
                                  60) /
                                  100
                              ).split(".")[0]
                            } Sec.`
                          : ""
                      } / ${
                        (data.duration / 60)?.toString().split(".")[0] > 0
                          ? (data.duration / 60)?.toString().split(".")[0] + " Hour"
                          : ""
                      } ${data.duration % 60 > 0 ? `${data.duration % 60} Min.` : ""}`}
                    />
                  )}
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "flex-start", 
                    }}
                  >
                    <ContainerText style={{ margin: "17px 0 12px 0" }}>Red Flags</ContainerText>
                    <div style={{ position: "relative" }}>
                      {parseInt(data.red_flag) == 0 ? (
                        <img alt="" src={greenFlag} width={80} height={80} />
                      ) : parseInt(data.red_flag) <= 2 ? (
                        <img alt="" src={orangeFlag} width={80} height={80} />
                      ) : (
                        <img alt="" src={RedFlagsImage} width={80} height={80} />
                      )}
                      <RedFlags>{data?.red_flag}</RedFlags>
                    </div>
                    {!(data?.totalMock > 0) && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Text>{"Time taken"}</Text>
                        <ScoreValues>{`${
                          data?.progress_min?.toString().split(".")[0]
                        } Min. ${
                          data?.progress_min.toString()?.split(".")[1]
                            ? `${
                                String(
                                  (Number(
                                    data?.progress_min
                                      .toString()
                                      ?.split(".")[1]
                                      .slice(0, 2)
                                      .padEnd(2, "0")
                                  ) *
                                    60) /
                                    100
                                ).split(".")[0]
                              } Sec.`
                            : ""
                        } / ${
                          (data.duration / 60)?.toString().split(".")[0] > 0
                            ? (data.duration / 60)?.toString().split(".")[0] + " Hour"
                            : ""
                        } ${data.duration % 60 > 0 ? `${data.duration % 60} Min.` : ""}`}</ScoreValues>
                      </div>
                    )}
                  </div>
                </ScoreWrapper>

                <Line />

                {/* ── Skill Score ── */}
                <SectionHeading>Skill Score</SectionHeading>
                <div
                  style={{
                    display: "flex",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {(Object.keys(data?.skillGraph || {}).length > 0) && (
                    <div style={{ display: "flex", height: "100%" }}>
                      <LeftSideSkillContainer>
                        {Object.keys(data?.skillGraph).map((i) => {
                          return <span key={i}>{i}</span>;
                        })}
                      </LeftSideSkillContainer>

                      <div>
                        <ProgressContainer>
                          {Object.keys(data?.skillGraph).map((i) => {
                            let { correct_marks, total_marks } = data?.skillGraph[i];
                            const pct = total_marks
                              ? Math.round(
                                  (Math.round(correct_marks) / total_marks) * 100
                                )
                              : 0;
                            const passing = data?.passing_percentages?.[i];
                            return (
                              <ProgressBarWrapper key={i}>
                                <Progress
                                  status={"normal"}
                                  strokeLinecap={"square"}
                                  strokeWidth={14}
                                  showInfo={false}
                                  strokeColor={skillBarColor(pct, passing)}
                                  percent={pct}
                                />
                                {passing != null &&
                                  passing !== "" &&
                                  !Number.isNaN(Number(passing)) && (
                                    <PassingMarker
                                      style={{
                                        left: `${Math.min(
                                          100,
                                          Math.max(0, Number(passing))
                                        )}%`,
                                      }}
                                    />
                                  )}
                              </ProgressBarWrapper>
                            );
                          })}
                        </ProgressContainer>
                        <PercentContainer>
                          <span style={{ left: "0%" }}>0%</span>
                          <span style={{ left: "20%" }}>20%</span>
                          <span style={{ left: "40%" }}>40%</span>
                          <span style={{ left: "60%" }}>60%</span>
                          <span style={{ left: "80%" }}>80%</span>
                          <span style={{ left: "100%" }}>100%</span>
                        </PercentContainer>
                      </div>
                    </div>
                  )}
                  {(data?.totalCompiler > 0 || data?.totalSQL > 0) && (
                    <RightScoreContainer
                      hideBorder={
                        !(Object.keys(data?.skillGraph || {}).length > 0)
                      }
                    >
                      <Score
                        title={"Coding Score"}
                        removeMargin={true}
                        color={
                          data?.codingPercentage < 40
                            ? "rgba(240, 70, 57, 1)"
                            : data.codingPercentage >= 40 && data.codingPercentage <= 60
                            ? "rgba(246, 140, 80, 1)"
                            : "#0DC10A"
                        }
                        percent={data?.codingPercentage}
                        stroke={12}
                        size={140}
                        text={"Coding language:"}
                        boldText={`${
                          data?.codingLanguage?.length > 0
                            ? data.codingLanguage.join(", ")
                            : "NA"
                        }`}
                      />
                    </RightScoreContainer>
                  )}
                </div>
              </ContainerBox>

              {/* ── Assessment Recording ── */}
              {data?.screenrecording_url && (
                <ContainerBox>
                  <SectionHeading>Assessment recording:</SectionHeading>
                  <RecordingCard backgroundImage={data.file_image}>
                    <a
                      href={data?.screenrecording_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        position: "absolute",
                      }}
                    >
                      <PlayCircleOutlined
                        style={{ fontSize: "36px", color: "#1b49ea" }}
                      />
                    </a>
                  </RecordingCard>
                </ContainerBox>
              )}

              {/* ── Detailed Submission Report ── */}
              <ContainerBox top={data?.screenrecording_url ? "" : "50px"}>
                <SectionHeading>Detailed submission report</SectionHeading>

                {/* AI Interview Questions */}
                {data?.mockDetails.length > 0 && (
                  <AssessmentTypeHeading>
                    <div>
                      AI Interview Questions ({data?.mockAttempted}/
                      {data.totalMock} attempted)
                    </div>
                    <div>
                      Time taken:{" "}
                      {data.completeMockTime ? (
                        <span>{`${
                          data.completeMockTime > 60
                            ? parseInt(data.completeMockTime / 60) +
                              " Min." +
                              (data.completeMockTime % 60) +
                              " sec."
                            : (data.completeMockTime % 60) + " sec."
                        } `}</span>
                      ) : (
                        <span>-</span>
                      )}
                    </div>
                  </AssessmentTypeHeading>
                )}

                {data?.mockDetails.length > 0 && (
                  <ListingContainer>
                    {data?.mockDetails?.map((it) => {
                      return (
                        <ItemContainer key={it.id || it.questionTitle}>
                          <MockQuestionContainer>
                            <div style={{ width: "70px" }}>
                              Q. No. {count++}
                            </div>
                            <p>
                              Skill:{" "}
                              <span style={{ fontWeight: 600 }}>
                                {it.skill_name}
                              </span>
                            </p>
                            {visibleTopicName(it.topic_name) ? (
                            <p>
                              Topic:{" "}
                              <span style={{ fontWeight: 600 }}>
                                {visibleTopicName(it.topic_name)}
                              </span>
                            </p>
                            ) : null}
                            <p>
                              Answer Accuracy:{" "}
                              {it.ansRecording ? (
                                <span style={{ fontWeight: 600 }}>
                                  {it.accuracy}%
                                </span>
                              ) : (
                                <span style={{ fontWeight: 600 }}>-</span>
                              )}
                            </p>
                            <p>
                              Communication proficiency:{" "}
                              {it.ansRecording ? (
                                <span style={{ fontWeight: 600 }}>
                                  {it.grammar}%
                                </span>
                              ) : (
                                <span style={{ fontWeight: 600 }}>-</span>
                              )}
                            </p>
                            <p>
                              Time taken:{" "}
                              {it.time_spent ? (
                                <span style={{ fontWeight: 600 }}>{`${
                                  it.time_spent > 60
                                    ? parseInt(it.time_spent / 60) +
                                      " Min." +
                                      (it.time_spent % 60) +
                                      " sec."
                                    : (it.time_spent % 60) + " sec."
                                } `}</span>
                              ) : (
                                <span style={{ fontWeight: 600 }}>-</span>
                              )}
                            </p>
                          </MockQuestionContainer>

                          <div style={{ display: "flex" }}>
                            <div style={{ width: "70px", flexShrink: 0 }}></div>
                            <span style={{ fontSize: "12px" }}>
                              {it?.questionTitle}
                            </span>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={{ width: "70px" }}></div>
                            <span
                              style={{
                                fontSize: "12px",
                                marginTop: "10px",
                                fontWeight: 600,
                              }}
                            >
                              Candidate answer:
                            </span>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={{ width: "70px" }}></div>
                            {it.ansRecording ? (
                              <RecordingLink href={it.ansRecording}>
                                Click here for answer's recording
                              </RecordingLink>
                            ) : (
                              <RecordingLink>
                                <p>
                                  This candidate has not answered this question.
                                </p>
                              </RecordingLink>
                            )}
                          </div>
                        </ItemContainer>
                      );
                    })}
                  </ListingContainer>
                )}

                {/* MCQ Questions */}
                {data.totalMCQ > 0 && (
                  <div>
                    <AssessmentTypeHeading>
                      <div>
                        Multiple choice questions ({data?.mcqQuestionAttempted}/
                        {data?.totalMCQ} attempted)
                      </div>
                      <div>
                        Time taken:{" "}
                        {data.completeMcqTime ? (
                          <span>{`${
                            data.completeMcqTime > 60
                              ? parseInt(data.completeMcqTime / 60) +
                                " Min." +
                                (data.completeMcqTime % 60) +
                                " sec."
                              : (data.completeMcqTime % 60) + " sec."
                          } `}</span>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    </AssessmentTypeHeading>
                    {data?.formated_questions_data.map((it) => {
                      return (
                        it.questionTypeCode === "MCQ" && (
                          <McqContainer key={it.id || it.questionNo}>
                            <CodingQuestionContainer>
                              <p>Q. No. {count++}</p>
                              {it.isAttempted ? (
                                it.isCorrect ? (
                                  <p>
                                    <img src={correctIcon} /> Correct Answer
                                  </p>
                                ) : (
                                  <p>
                                    <img src={inCorrectIcon} />
                                    Incorrect Answer
                                  </p>
                                )
                              ) : (
                                <p>Not attempted</p>
                              )}
                              <p>
                                Skill: <span>{it?.skill_name}</span>
                              </p>
                              {visibleTopicName(it?.topic_name) ? (
                              <p>
                                Topic: <span>{visibleTopicName(it?.topic_name)}</span>
                              </p>
                              ) : null}
                              <p>
                                Score:{" "}
                                <span>
                                  {it?.correctMarks}/{it?.questionMarks}
                                </span>
                              </p>
                              <p>
                                Time taken:{" "}
                                {it.time_spent ? (
                                  <span>{`${
                                    it.time_spent > 60
                                      ? parseInt(it.time_spent / 60) +
                                        " Min." +
                                        (it.time_spent % 60) +
                                        " sec."
                                      : (it.time_spent % 60) + " sec."
                                  } `}</span>
                                ) : (
                                  <span>-</span>
                                )}
                              </p>
                            </CodingQuestionContainer>
                            <CodingQuestionDetail>
                              {it.questionText}
                            </CodingQuestionDetail>
                            <BoldText
                              marginBottom={"15px"}
                              fontWeight={600}
                              fontSize={"12px"}
                              marginTop={"20px"}
                            >
                              Options
                            </BoldText>
                            {it.options.map((i) => {
                              return (
                                <OptionWrapper
                                  key={i.option}
                                  correct={
                                    i?.isSelected === true ? i?.isCorrect : ""
                                  }
                                >
                                  {i.option}
                                  {it.isAttempted ? (
                                    i?.isCorrect ? (
                                      <img src={correctIcon} />
                                    ) : (
                                      i?.isSelected && (
                                        <img src={inCorrectIcon} />
                                      )
                                    )
                                  ) : (
                                    ""
                                  )}
                                </OptionWrapper>
                              );
                            })}
                          </McqContainer>
                        )
                      );
                    })}
                  </div>
                )}

                {/* DSA Coding Questions */}
                {data?.totalCompiler > 0 && (
                  <div>
                    <AssessmentTypeHeading>
                      <div>
                        DSA Coding Questions ({data?.compilerQuestionAttempted}/
                        {data?.totalCompiler} attempted)
                      </div>
                      <div>
                        Time taken:{" "}
                        {data.completeCodingTime ? (
                          <span>{`${
                            data.completeCodingTime > 60
                              ? parseInt(data.completeCodingTime / 60) +
                                " Min." +
                                (data.completeCodingTime % 60) +
                                " sec."
                              : (data.completeCodingTime % 60) + " sec."
                          } `}</span>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    </AssessmentTypeHeading>
                    {data?.formated_questions_data?.map((it) => {
                      return (
                        it.questionTypeCode === "COMPILER" && (
                          <CodingContainer key={it.id || it.questionNo}>
                            <CodingQuestionContainer>
                              <p>Q. No. {count++}</p>
                              <p>
                                Type: <span>DSA Coding Question</span>
                              </p>
                              <p>
                                Correct test cases:{" "}
                                <span>
                                  {it.totalCorrect}/{it.totalOption}
                                </span>
                              </p>
                              <p>
                                Coding languages:{" "}
                                <span>{it.codingLanguage}</span>
                              </p>
                              <p>
                                Score:{" "}
                                <span>
                                  {it.correctMarks}/{it.questionMarks}
                                </span>
                              </p>
                              <p>
                                Time taken:{" "}
                                {it.time_spent ? (
                                  <span>{`${
                                    it.time_spent > 60
                                      ? parseInt(it.time_spent / 60) +
                                        " Min." +
                                        (it.time_spent % 60) +
                                        " sec."
                                      : (it.time_spent % 60) + " sec."
                                  } `}</span>
                                ) : (
                                  <span>-</span>
                                )}
                              </p>
                            </CodingQuestionContainer>
                            <CodingQuestionDetail>
                              {it?.questionText}
                            </CodingQuestionDetail>
                            <CandidateCodeHeading>
                              Candidate code:
                            </CandidateCodeHeading>
                            {it.candidate_code ? (
                              <CandidateCode>{it.candidate_code}</CandidateCode>
                            ) : (
                              <CandidateCode
                                red={true}
                                fontWeight={500}
                                fontSize={"12px"}
                              >
                                Not Answered
                              </CandidateCode>
                            )}
                          </CodingContainer>
                        )
                      );
                    })}
                  </div>
                )}

                {/* SQL Coding Questions */}
                {data?.totalSQL > 0 && (
                  <div>
                    <AssessmentTypeHeading>
                      <div>
                        SQL Coding Questions ({data?.sqlQuestionAttempted}/
                        {data?.totalSQL} attempted)
                      </div>
                      <div>
                        Time taken:{" "}
                        {data.completeSqlTime ? (
                          <span>{`${
                            data.completeSqlTime > 60
                              ? parseInt(data.completeSqlTime / 60) +
                                " Min." +
                                (data.completeSqlTime % 60) +
                                " sec."
                              : (data.completeSqlTime % 60) + " sec."
                          } `}</span>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    </AssessmentTypeHeading>
                    {data?.formated_questions_data?.map((it) => {
                      return (
                        it.questionTypeCode === "SQL" && (
                          <CodingContainer key={it.id || it.questionNo}>
                            <CodingQuestionContainer>
                              <p>Q. No. {count++}</p>
                              <p>
                                Correct test cases:{" "}
                                <span>
                                  {it.totalCorrect}/{it.totalOption}
                                </span>
                              </p>
                              <p>
                                Type: <span>SQL Coding Question</span>
                              </p>
                              <p>
                                Score:{" "}
                                <span>
                                  {it.correctMarks}/{it.questionMarks}
                                </span>
                              </p>
                              <p>
                                Time taken:{" "}
                                {it.time_spent ? (
                                  <span>{`${
                                    it.time_spent > 60
                                      ? parseInt(it.time_spent / 60) +
                                        " Min." +
                                        (it.time_spent % 60) +
                                        " sec."
                                      : (it.time_spent % 60) + " sec."
                                  } `}</span>
                                ) : (
                                  <span>-</span>
                                )}
                              </p>
                            </CodingQuestionContainer>
                            <CodingQuestionDetail>
                              {it?.questionText}
                            </CodingQuestionDetail>
                            <CandidateCodeHeading>
                              Candidate query:
                            </CandidateCodeHeading>
                            {it.candidate_code ? (
                              <CandidateCode>{it.candidate_code}</CandidateCode>
                            ) : (
                              <CandidateCode
                                red={true}
                                fontWeight={500}
                                fontSize={"12px"}
                              >
                                Not Answered
                              </CandidateCode>
                            )}
                          </CodingContainer>
                        )
                      );
                    })}
                  </div>
                )}
              </ContainerBox>

              <p style={{ textAlign: "center" }}>
                This report is generated by{" "}
                <span style={{ color: "rgba(255, 44, 145, 1)" }}>
                  Coffeee.io
                </span>
              </p>
            </ReportContentWrapper>
          </div>
        )}
      </div>
    </div>
  );
};

export default Report;